import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=1c8b43a6&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=ts&"
export * from "./Voucher.vue?vue&type=script&lang=ts&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=1c8b43a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8b43a6",
  null
  
)

export default component.exports